export default "__VITE_PUBLIC_ASSET__0557d618__"